import { useEffect, useState } from 'react';

/**
 * Petit hook de chargement de données.
 * @param {() => Promise<{data:any, live?:boolean, preview?:boolean}>} fn
 * @returns {{loading:boolean, data:any, live:boolean, preview:boolean}}
 */
export function useApi(fn, deps = []) {
  const [state, setState] = useState({ loading: true, data: null, live: false, preview: false });

  useEffect(() => {
    let cancelled = false;
    Promise.resolve(fn()).then((r) => {
      if (!cancelled) {
        setState({ loading: false, data: r.data, live: !!r.live, preview: !!r.preview });
      }
    });
    return () => { cancelled = true; };
  }, deps);

  return state;
}
